module.exports = __webpack_public_path__ + "img/simulateur_credit_conso.580d1935.jpg";